export default {
  today: 'Aujourd\'hui',
  now: 'Maintenant',
  backToToday: 'Aujourd\'hui',
  ok: 'Ok',
  clear: 'Rétablir',
  month: 'Mois',
  year: 'Année',
  timeSelect: 'Sélectionner l\'heure',
  dateSelect: 'Sélectionner la date',
  monthSelect: 'Choisissez un mois',
  yearSelect: 'Choisissez une année',
  decadeSelect: 'Choisissez une décennie',
  yearFormat: 'YYYY',
  dateFormat: 'DD/MM/YYYY',
  dayFormat: 'DD',
  dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Mois précédent (PageUp)',
  nextMonth: 'Mois suivant (PageDown)',
  previousYear: 'Année précédente (Ctrl + gauche)',
  nextYear: 'Année prochaine (Ctrl + droite)',
  previousDecade: 'Décennie précédente',
  nextDecade: 'Décennie suivante',
  previousCentury: 'Siècle précédent',
  nextCentury: 'Siècle suivant',
}



// WEBPACK FOOTER //
// ./components/vc-calendar/src/locale/fr_FR.js